module.exports = __webpack_public_path__ + "bcfb7abb9e06f9538c2320397deeaca7.jpg";